import {IRange} from "@pg-design/range-module";
import {isNumber} from "@pg-mono/nodash";

import {isValueInRange} from "./is_value_in_range";

type IRangeType = IRange<number | "">;

const getValidLower = (lower: IRangeType["lower"], min: number) => Math.max(lower || min, min);
const getValidUpper = (upper: IRangeType["upper"], max: number) => Math.min(upper || max, max);

const validateBound = (value: IRangeType, filterOptionValueMin: number, filterOptionValueMax: number): IRangeType => {
    const {lower, upper} = value;
    // open bounds
    if (!Number.isFinite(lower) && !Number.isFinite(upper)) {
        // undefined bounds
        return value;
    }
    if (!Number.isFinite(lower) && isNumber(upper, true)) {
        // no left bound
        return upper < filterOptionValueMin
            ? {lower: "", upper: ""} // invalid upper bound
            : upper < filterOptionValueMax
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    if (!Number.isFinite(upper) && isNumber(lower, true)) {
        // no right bound
        return lower > filterOptionValueMax
            ? {lower: "", upper: ""} // invalid lower bound
            : lower > filterOptionValueMin
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    // defined bounds
    if (isNumber(upper, true) && isNumber(lower, true)) {
        if (upper < lower) {
            // error bound
            return {lower: "", upper: ""};
        }
        if (lower <= filterOptionValueMin && upper >= filterOptionValueMax) {
            // border bounds
            return {lower: filterOptionValueMin, upper: filterOptionValueMax};
        }
        if (lower <= filterOptionValueMin) {
            // border left bound - keep the minimum value instead of empty string
            return {lower: filterOptionValueMin, upper};
        }
        if (upper >= filterOptionValueMax) {
            // border right bound - keep the maximum value instead of empty string
            return {lower, upper: filterOptionValueMax};
        }
    }

    return value;
};

const getNextAvailableBound = (
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    diff: number,
    availableOptionValues: number[]
): number => {
    const newOption = filterOptionValue + diff;
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    const isNewOptionAvailable = availableOptionValues.some((option: number) => option === newOption);
    if (isNewOptionAvailable) {
        return newOption;
    }

    // if out of range set 0
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    switch (newOption) {
        case filterOptionValueMin:
            return filterOptionValueMin;
        case filterOptionValueMax:
            return filterOptionValueMax;
        default:
            return getNextAvailableBound(newOption, filterOptionValueMin, filterOptionValueMax, diff, availableOptionValues);
    }
};

function updateValueBoundsNotValidated(
    value: IRangeType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
): IRangeType {
    const {lower, upper} = value;
    if (!lower && !upper) {
        return {lower: filterOptionValue, upper: filterOptionValue};
    }
    const validLower = getValidLower(lower, filterOptionValueMin);
    const validUpper = getValidUpper(upper, filterOptionValueMax);
    if (isValueInRange(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax)) {
        // cut the range
        const leftDistance = Math.abs(filterOptionValue - validLower);
        const rightDistance = Math.abs(filterOptionValue - validUpper);
        // cut (left or right) values up to the `option` point
        const isLeftDistanceLower = leftDistance < rightDistance;
        const newLower = isLeftDistanceLower
            ? getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, 1, availableOptionValues)
            : lower;
        const newUpper = isLeftDistanceLower
            ? upper
            : getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, -1, availableOptionValues);

        return isLeftDistanceLower ? {lower: newLower, upper} : {lower, upper: newUpper};
    } else {
        // expand the range => left or right
        return filterOptionValue < validLower ? {lower: filterOptionValue, upper} : {lower, upper: filterOptionValue};
    }
}

/**
 * Updates range bounds based on clicked option value.
 * Either expands or cuts the range depending on current state.
 *
 * @param value - Current range value
 * @param filterOptionValue - The clicked option value
 * @param filterOptionValueMin - Minimum possible value
 * @param filterOptionValueMax - Maximum possible value
 * @param availableOptionValues - Array of all available option values
 * @returns Updated range value
 */
export const updateValueBounds = (
    value: IRangeType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
) => {
    return validateBound(
        updateValueBoundsNotValidated(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax, availableOptionValues),
        filterOptionValueMin,
        filterOptionValueMax
    );
};
import {IRange} from "@pg-design/range-module";
import {isNumber} from "@pg-mono/nodash";

import {isValueInRange} from "./is_value_in_range";

type IRangeType = IRange<number | "">;

const getValidLower = (lower: IRangeType["lower"], min: number) => Math.max(lower || min, min);
const getValidUpper = (upper: IRangeType["upper"], max: number) => Math.min(upper || max, max);

const validateBound = (value: IRangeType, filterOptionValueMin: number, filterOptionValueMax: number): IRangeType => {
    const {lower, upper} = value;
    // open bounds
    if (!Number.isFinite(lower) && !Number.isFinite(upper)) {
        // undefined bounds
        return value;
    }
    if (!Number.isFinite(lower) && isNumber(upper, true)) {
        // no left bound
        return upper < filterOptionValueMin
            ? {lower: "", upper: ""} // invalid upper bound
            : upper < filterOptionValueMax
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    if (!Number.isFinite(upper) && isNumber(lower, true)) {
        // no right bound
        return lower > filterOptionValueMax
            ? {lower: "", upper: ""} // invalid lower bound
            : lower > filterOptionValueMin
              ? value
              : {lower: filterOptionValueMin, upper: filterOptionValueMax};
    }
    // defined bounds
    if (isNumber(upper, true) && isNumber(lower, true)) {
        if (upper < lower) {
            // error bound
            return {lower: "", upper: ""};
        }
        if (lower <= filterOptionValueMin && upper >= filterOptionValueMax) {
            // border bounds
            return {lower: filterOptionValueMin, upper: filterOptionValueMax};
        }
        if (lower <= filterOptionValueMin) {
            // border left bound - keep the minimum value instead of empty string
            return {lower: filterOptionValueMin, upper};
        }
        if (upper >= filterOptionValueMax) {
            // border right bound - keep the maximum value instead of empty string
            return {lower, upper: filterOptionValueMax};
        }
    }

    return value;
};

const getNextAvailableBound = (
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    diff: number,
    availableOptionValues: number[]
): number => {
    const newOption = filterOptionValue + diff;
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    const isNewOptionAvailable = availableOptionValues.some((option: number) => option === newOption);
    if (isNewOptionAvailable) {
        return newOption;
    }

    // if out of range set 0
    if (newOption < filterOptionValueMin || newOption > filterOptionValueMax) {
        return 0;
    }

    switch (newOption) {
        case filterOptionValueMin:
            return filterOptionValueMin;
        case filterOptionValueMax:
            return filterOptionValueMax;
        default:
            return getNextAvailableBound(newOption, filterOptionValueMin, filterOptionValueMax, diff, availableOptionValues);
    }
};

function updateValueBoundsNotValidated(
    value: IRangeType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
): IRangeType {
    const {lower, upper} = value;
    if (!lower && !upper) {
        return {lower: filterOptionValue, upper: filterOptionValue};
    }
    const validLower = getValidLower(lower, filterOptionValueMin);
    const validUpper = getValidUpper(upper, filterOptionValueMax);
    if (isValueInRange(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax)) {
        // cut the range
        const leftDistance = Math.abs(filterOptionValue - validLower);
        const rightDistance = Math.abs(filterOptionValue - validUpper);
        // cut (left or right) values up to the `option` point
        const isLeftDistanceLower = leftDistance < rightDistance;
        const newLower = isLeftDistanceLower
            ? getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, 1, availableOptionValues)
            : lower;
        const newUpper = isLeftDistanceLower
            ? upper
            : getNextAvailableBound(filterOptionValue, filterOptionValueMin, filterOptionValueMax, -1, availableOptionValues);

        return isLeftDistanceLower ? {lower: newLower, upper} : {lower, upper: newUpper};
    } else {
        // expand the range => left or right
        return filterOptionValue < validLower ? {lower: filterOptionValue, upper} : {lower, upper: filterOptionValue};
    }
}

/**
 * Updates range bounds based on clicked option value.
 * Either expands or cuts the range depending on current state.
 *
 * @param value - Current range value
 * @param filterOptionValue - The clicked option value
 * @param filterOptionValueMin - Minimum possible value
 * @param filterOptionValueMax - Maximum possible value
 * @param availableOptionValues - Array of all available option values
 * @returns Updated range value
 */
export const updateValueBounds = (
    value: IRangeType,
    filterOptionValue: number,
    filterOptionValueMin: number,
    filterOptionValueMax: number,
    availableOptionValues: number[]
) => {
    return validateBound(
        updateValueBoundsNotValidated(value, filterOptionValue, filterOptionValueMin, filterOptionValueMax, availableOptionValues),
        filterOptionValueMin,
        filterOptionValueMax
    );
};
